export enum FOHFonts {
  REGULAR = 'Assistant',
  MEDIUM = 'AssistantMedium',
  BOLD = 'AssistantBold'
}
